import { signal, WritableSignal } from '@angular/core';
import {
    FieldAndInput,
    FormBlueprint,
} from 'src/app/layouts/ui/form/formTypes';

export class MutationInput {
    values: WritableSignal<{ [key: string]: any }> = signal<{
        [key: string]: any;
    }>({});
    formBlueprint: FormBlueprint;

    constructor(formBlueprint: FormBlueprint) {
        this.formBlueprint = formBlueprint;
        this.values.set(formBlueprint.values);
    }

    public getFormField = (key: string): FieldAndInput =>
        this.formBlueprint.getFormField(key);

    public clearValues = () => {
        const existingValues = Object.keys(this.values());
        existingValues.forEach((key) => {
            this.values()[key] = undefined;
        });
    };

    public setValues(values: any) {
        const existingValues = Object.keys(this.values());
        Object.keys(values).forEach((key) => {
            if (existingValues.includes(key)) {
                this.values.update((data) => ({ ...data, [key]: values[key] }));
            }
        });
        this.formBlueprint.fields.forEach((fieldInput) => {
            if (fieldInput.field.populate)
                this.values()[fieldInput.field.key] =
                    fieldInput.field.populate(values);
        });
    }

    public get(): any {
        if (!this.values) return null;

        const values: { [key: string]: any } = {};
        this.formBlueprint.fields.forEach((fieldInput) => {
            if (!fieldInput.field.notReturned)
                values[fieldInput.field.key] =
                    this.values()[fieldInput.field.key];
        });
        return this.values() ? { input: values } : { input: null };
    }
}
